import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

// Helpers
import { clone } from "@/Common/helpers/Modifiers/formatters";

// Layouts
import CustomerSatisfactionLoader from "@/Layouts/components/Skeletons/CustomerSatisfactionLoader/CustomerSatisfactionLoader";

// Custom components
import PinnacleModel from "./PinnacleModel";

// MUI
import { Grid } from "@mui/material";

export default function Pinnacle(props) {
	const {
		sectionId = "pinnacle",
		department = "SALES",
		content = {
			oemReference: "GM",
			version: "",
			metrics: [],
			tiers: [],
		},
		loading = false,
		readOnly = false,
		useSectionsErrors = () => {},
		onActionUpdate = () => {},
	} = props;

	// States
	// eslint-disable-next-line no-unused-vars
	const [isValidModels, setIsValidModels] = useState(true);
	const [model, setModel] = useState(null);

	// Hooks
	const { errors, addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	// Actions handlers
	const update = (section, data) => {
		setModel({ ...data });
		onActionUpdate?.(section, null, { ...data });
	};

	const handleUpdate = (section, data) => {
		const updatedModel = { ...model, ...data };
		removeSectionError(section); // Remove the area error
		update(section, updatedModel);
	};

	const handleValidation = (section, value) => {
		value ? removeSectionError(section) : addSectionError(section);
	};

	useMemo(() => {
		const sectionErrors = errors?.get(sectionId) || [];
		setIsValidModels(!sectionErrors.length);
	}, [sectionId, errors]);

	useEffect(() => {
		setModel(clone(content));
		return () => {
			setModel(null);
		};
	}, [content]);

	useEffect(() => {
		return () => {
			clearSectionErrors(sectionId);
			setIsValidModels(true);
		};
	}, [sectionId, clearSectionErrors]);

	return (
		<Grid container px={"32px"}>
			<Grid item xs={12} mt={2.5}>
				{loading ? (
					<Grid>
						<CustomerSatisfactionLoader title buttons inputs sx={{ padding: "0" }} />
					</Grid>
				) : (
					Boolean(model) && (
						<Grid container>
							<Grid item xs={12} className={"models-tiered-area"}>
								<PinnacleModel
									model={model}
									department={department}
									readOnly={readOnly}
									onActionUpdate={(makeMetrics) => handleUpdate(sectionId, makeMetrics)}
									onActionValidation={(isValid) => handleValidation(sectionId, isValid)}
								/>
							</Grid>
						</Grid>
					)
				)}
			</Grid>
		</Grid>
	);
}
Pinnacle.propTypes = {
	sectionId: PropTypes.string,
	department: PropTypes.string,
	content: PropTypes.shape({
		oemReference: PropTypes.string,
		version: PropTypes.string,
		metrics: PropTypes.array,
		tiers: PropTypes.array,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
